import React from 'react';
import styled from 'styled-components';
import * as colors from '../../../../colors';
export default function FormHeaderText({ children, className, }) {
    return (React.createElement(StyledFormHeaderText, { className: className }, children));
}
const StyledFormHeaderText = styled.span `
  color: ${colors.FONT_SECONDARY};
  font-weight: bold;
  display: flex;
  align-items: center;
`;
